module.exports = __webpack_public_path__ + "img/firefox.4a754f3d.png";